import { ICON_DEFAULT_FOREGROUND_COLOR } from '../../../graphConstants';
import {
  type NodeIconOptions,
  type NodeTypeIcon,
  nodeIconDefaultOptions,
} from '../NodeTypeIcon';
import {
  createCircleNodeTypeIcon,
  getArrowSvgPath,
  wrapNodeIconInSvgTag,
} from '../common';
import { drawCircleBackground } from '../drawIconBackground';

const DIAMETER = 40;

const getCloudLbArrowSvgPath = (side: number) =>
  getArrowSvgPath({
    from: { x: -9, y: 0 },
    to: { x: 6, y: side * 9.8 },
    headWidth: 5,
    headHeight: 4.5,
    tailWidth: 1.7,
  });

function createCloudLoadBalancerIcon(options: NodeIconOptions = {}): string {
  const opts = { ...nodeIconDefaultOptions, ...options };

  const icon = `
  ${drawCircleBackground(DIAMETER / 2, opts.style)}
  <rect x="-15.9" y="-5.3" width="7.2" height="10.6" fill="${ICON_DEFAULT_FOREGROUND_COLOR}" />
  <rect x="6.5" y="-13.2" width="6.4" height="6.4" fill="${ICON_DEFAULT_FOREGROUND_COLOR}" />
  <rect x="6.5" y="-3.2" width="6.4" height="6.4" fill="${ICON_DEFAULT_FOREGROUND_COLOR}" />
  <rect x="6.5" y="6.8" width="6.4" height="6.4" fill="${ICON_DEFAULT_FOREGROUND_COLOR}" />
  <path fill="${ICON_DEFAULT_FOREGROUND_COLOR}" d="${getCloudLbArrowSvgPath(-1)}" />
  <path fill="${ICON_DEFAULT_FOREGROUND_COLOR}" d="${getCloudLbArrowSvgPath(0)}" />
  <path fill="${ICON_DEFAULT_FOREGROUND_COLOR}" d="${getCloudLbArrowSvgPath(1)}" />
`;

  return wrapNodeIconInSvgTag(icon, DIAMETER, DIAMETER, 'center', opts);
}

export const cloudLoadBalancerIcon: NodeTypeIcon = createCircleNodeTypeIcon(
  DIAMETER,
  createCloudLoadBalancerIcon,
);
